var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"404"}},[_c('h1',[_vm._v("Oups!")]),_c('h2',[_vm._v("Il s'emblerait que cette page n'existe pas...")])])}]

export { render, staticRenderFns }